/**
 * UserFilterBar.jsx — the "User-wise Count" tab's own controls.
 *
 * Kept apart from LogFilterBar on purpose: that strip filters LOGS (query id,
 * log type, shipping line, date range), none of which a per-user total is
 * picked by. Both of these are applied to the rows already fetched — the
 * /user-counts aggregation returns every matching user in one response — so
 * neither fires a read.
 */
import React from "react";
import { Select } from "antd";
import { Search } from "lucide-react";
import { USER_SORT_OPTIONS } from "./logUtils";

function Field({ label, children }) {
  return (
    <div className="flex flex-col gap-1.5">
      <label className="text-[11px] font-semibold tracking-wide text-gray-500 uppercase">{label}</label>
      {children}
    </div>
  );
}

function UserFilterBar({ search, sortBy, onChange }) {
  return (
    <div className="px-5 py-5 rounded-xl border border-gray-200 bg-white">
      <div className="grid grid-cols-2 gap-5 sm:grid-cols-1">
        <Field label="Search user">
          <span className="relative block">
            <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              className="w-full h-10 pl-9 pr-3 rounded-lg bg-[#F7F8FA] border border-gray-200 text-[13px] text-gray-700 outline-none focus:border-primary"
              placeholder="Name or email..."
              value={search}
              onChange={(event) => onChange({ search: event.target.value, sortBy })}
            />
          </span>
        </Field>

        <Field label="Sort by">
          <Select
            size="large"
            className="w-full"
            value={sortBy}
            onChange={(value) => onChange({ search, sortBy: value })}
            options={USER_SORT_OPTIONS}
          />
        </Field>
      </div>
    </div>
  );
}

export default UserFilterBar;
